import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { memo as f, forwardRef as p } from "react";
import { makeClassesByStyles as N } from "../../../../utils/classes.js";
import { Icon as s } from "../icon/icon.js";
import { IconTypeMap as d, NotificationType as y } from "./notification-types.js";
import x from "../../../../assets/e11a4012.notification.module.css";
const e = N(x), C = f(
  p(
    ({
      className: i,
      type: t = y.DEFAULT,
      children: m,
      isDismissible: r = !0,
      onClose: c,
      style: a
    }, l) => /* @__PURE__ */ n(
      "div",
      {
        ref: l,
        className: e("Notification", `--${t}`, i),
        style: a,
        children: [
          /* @__PURE__ */ o("div", { className: e("icon"), children: /* @__PURE__ */ o(s, { name: d[t] }) }),
          /* @__PURE__ */ o("p", { className: e("text"), children: m }),
          r ? /* @__PURE__ */ o("button", { className: e("close"), onClick: c, children: /* @__PURE__ */ o(s, { name: "close" }) }) : null
        ]
      }
    )
  )
);
export {
  C as Notification
};
